import { render, staticRenderFns } from "./redirection.vue?vue&type=template&id=7a64c3ec&scoped=true"
import script from "./redirection.vue?vue&type=script&lang=js"
export * from "./redirection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a64c3ec",
  null
  
)

export default component.exports